<template>
    <div class="container">
      <div class="common-header-wrap">
        <mt-header title="店铺入驻" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>
        <img class="back" src="../../../assets/image/sellerjoinin_back.png">
        <div class="wrapper mt-20" v-if="config && config.store_joinin_open!=0">
            <div class="btn-wrapper">
                <div v-if="config.store_joinin_open==1 || config.store_joinin_open==3" class="common-btn ds-button-large btn" @click="nextStep(1)">个人入驻</div>
                <div v-if="config.store_joinin_open==1 || config.store_joinin_open==2" class="common-btn ds-button-large btn" @click="nextStep(0)">企业入驻</div>
            </div>
            <div @click="onAgreement">
                <mt-checklist
                        v-model="value"
                        :options="options">
                </mt-checklist>
            </div>
        </div>
    </div>
</template>
<script>

import { Toast, MessageBox } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import { getStoreJoinin } from '../../../api/seller'
export default {
  components: {
  },
  data () {
    return {
      options: [{ label: '《同意商家入驻协议》', value: 1 }],
      value: [1]
    }
  },
  mounted () {
  },
  computed: {
      ...mapState({
          config: state => state.config.config
      })
  },
  created: function () {
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    getStoreJoinin().then(res => {
      var store_joinin = res.result.store_joinin
      if (store_joinin) {
          if(store_joinin.joinin_state == 30){
              MessageBox('初审失败', store_joinin.joinin_message)
          }
        if (store_joinin.joinin_state == 10 || store_joinin.joinin_state == 11 || store_joinin.joinin_state == 20 || store_joinin.joinin_state == 31) {
          this.$router.push({ name: 'SellerJoinin5' })
          return
        }
        if (store_joinin.joinin_state == 40) {
          Toast('您的店铺已开通')
          this.$router.push({ name: 'HomeSellerLogin' })
          return
        }

          this.sellerJoininSave({ storeJoinin: store_joinin })

      }
    }).catch(error => {
      Toast(error.message)
    })
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    ...mapMutations({
      sellerJoininSave: 'sellerJoininSave',
      sellerJoininTypeSave: 'sellerJoininTypeSave'
    }),
    nextStep (type) {
      this.sellerJoininTypeSave({ storeJoininType: type })
      this.$router.push({ name: 'SellerJoinin2' })
    },
    onAgreement () {
      this.$router.push({
        name: 'HomeDocument',
        query: { type: 'open_store' }
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
.common-header-wrap .common-header{box-shadow: unset}
    .container {
        background: #fff;
    }
.back{width:100%}
    .btn-wrapper{display: flex;padding:0 .5rem}
    .btn{margin:0 .5rem;flex:1}
</style>
